// Supervision (v1 §10.9): «Tomar caso» / reanudar and the project's evaluation (ficha). Schemas in api-supervision.ts.
import * as S from './api-supervision.js';
import { IdParam, route, W } from './route-def.js';

const Li = W({ leadInterestId: IdParam });

export const supervisionRoutes = {
  takeCase: route({
    method: 'POST', path: '/workspaces/:workspaceId/opportunities/:leadInterestId/take-case', summary: '«Tomar caso»: intervención temporal (LIA deja de contactar la oportunidad hasta reanudar)', tag: 'supervision',
    minRole: 'advisor', module: null, params: Li, body: S.TakeCaseSchema, response: S.CaseControlSchema,
  }),
  resumeCase: route({
    method: 'POST', path: '/workspaces/:workspaceId/opportunities/:leadInterestId/resume-case', summary: 'Reanudar a LIA tras una intervención temporal (nota + siguiente paso)', tag: 'supervision',
    minRole: 'advisor', module: null, params: Li, body: S.ResumeCaseSchema, response: S.CaseControlSchema,
  }),
  projectEvaluation: route({
    method: 'GET', path: '/workspaces/:workspaceId/projects/:projectId/evaluation', summary: 'Ficha del proyecto: casos que requieren atención + cumplimiento, resultados y calidad', tag: 'supervision',
    minRole: 'advisor', module: null, params: W({ projectId: IdParam }), query: S.ProjectEvaluationQuerySchema, response: S.ProjectEvaluationSchema,
  }),
};
